import axios from "functions/axios";

export const ListSettingsAPI = () =>
  axios.get("admin/settings/admin_list_settings/").then((res) => res.data);

export const UpdateSettingAPI = (data) =>
  axios.put("admin/settings/admin_update_setting/", data).then((res) => res.data);
